<template>
  <div class="set-match-row set-match-item">
    <checkbox
      :value="selected"
      class="set-match-checkbox"
      @input="$emit('toggle', $event)"
    />

    <div class="set-match-main">
      <span class="set-match-label">
        {{ item.subject || '—' }} {{ item.number || item.numberSlug || '—' }}
      </span>

      <div class="set-match-details">
        <div
          v-for="p in item.profiles || []"
          :key="p.profileId"
          class="set-match-detail-row"
        >
          <span class="set-match-detail-label">
            {{ p.label || '—' }}
          </span>
          <pill readonly no-margin>
            {{ graderLabel(p.grader) }}
          </pill>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileSetMatchRow',

  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    graderLabel(grader) {
      const g = (grader || '').toLowerCase();
      const map = { psa: 'PSA', sgc: 'SGC', cgc: 'CGC', beckett: 'BGS' };
      return map[g] || g;
    },
  },
};
</script>

<style lang="scss" scoped>
.set-match-row {
  display: flex;
  align-items: flex-start;
  gap: $gp;
}

.set-match-main {
  display: flex;
  flex-direction: column;
  gap: $gp * 0.25;
}

.set-match-checkbox {
  flex-shrink: 0;
  --checkbox-margin-bottom: 0;
}

.set-match-label {
  display: inline-flex;
  align-items: center;
  gap: $gp * 0.5;
  flex-wrap: wrap;
}

.set-match-details {
  display: flex;
  flex-direction: column;
  gap: $gp * 0.25;
  font-size: 14px;
}

.set-match-detail-row {
  display: flex;
  align-items: center;
  gap: $gp * 0.5;
}

.set-match-detail-label {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
